var React = require('react');

function ZoomOut (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.608 2.824A16.784 16.784 0 007.74 31.478a16.783 16.783 0 0028.652-11.871A16.786 16.786 0 0019.608 2.824zm-10.894.48a19.607 19.607 0 0127.198 27.197 19.607 19.607 0 01-34.42-18.396 19.609 19.609 0 017.222-8.8z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.037 19.482c0-.78.632-1.411 1.411-1.411h18.07a1.412 1.412 0 010 2.823h-18.07a1.41 1.41 0 01-1.411-1.412zm22.441 11.993a1.412 1.412 0 011.996 0L47.587 45.59a1.412 1.412 0 01-1.997 1.996L31.477 33.471a1.412 1.412 0 010-1.996z","key":1})]);
}

ZoomOut.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ZoomOut;

ZoomOut.default = ZoomOut;
